module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-114x114-2e95dd8e838bba54827505c4ad5966bf.png";